import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AssetData, Asset } from '../../../interfaces/masters/asset' ;
import { AssetApi } from '../api/asset.api';
import { HttpParams } from '@angular/common/http';
@Injectable()
export class AssetService extends AssetData {

    constructor(private api: AssetApi) {
      super();
    }
  
  
    list(url: string): Observable<Asset[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<Asset>{
        return this.api.getById(url);
    }
  
    create(url: string, data:Asset): Observable<Asset[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:Asset): Observable<Asset> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }

    assetRegMstlist<T>(url: string,queryParams?:HttpParams): Observable<T> {
      return this.api.assetRegMstList(url,queryParams)
    }
    assetRegMstCreate<T,R>(url: string, data:T): Observable<R> {
      return this.api.assetRegMstAdd(url,data);
    }
    assetRegMstById<T>(url:string,params:HttpParams): Observable<T>{
      return this.api.assetRegMstById(url,params);
    }
    assetRegMstUpdate<T,R>(url: string, data:T,params:HttpParams): Observable<R> {
      return this.api.assetRegMstupdate(url,data,params);
    }

  }
  